<template>
    <div class="offcanvas offcanvas-end offcanvas-01" id="offcanvasCreate" tabindex="-1"
        aria-labelledby="offcanvasCreateLabel">
        <div class="offcanvas-header">
            <h5 class="text-dark" id="offcanvasCreateLabel">{{ mode }} NAV</h5>
            <button class="btn btn-danger btn-sm" type="button" data-bs-dismiss="offcanvas" aria-label="Close"
                ref="btnClose">
                <i class="ic-close"></i>
            </button>
        </div>
        <div class="offcanvas-body">
            <div class="row">
                <form class="row align-end" v-on:submit.prevent="submitForm" enctype="multipart/form-data">
                    <div class="col-md-12 mb-16">
                        <label for="">Title</label>
                        <input type="text" class="form-control" v-model="item.title" @input="createSlug" />
                        <ErrorSpan :error="errors.title" />
                    </div>
                    <div class="col-md-6 mb-16">
                        <label for="">Slug</label>
                        <input type="text" class="form-control" v-model="item.slug" />
                        <ErrorSpan :error="errors.slug" />
                    </div>

                    <div class="col-md-6 mb-16">
                        <label for="">Scheme</label>
                        <select name="scheme_id" class="form-select" :class="{ 'border-red': errors.scheme_id }"
                            v-model="item.scheme_id">
                            <option value="" selected>Select Fund</option>
                            <option v-for="(type, key) in schemes" :key="key" :value="type.id">{{ type.title }}</option>
                        </select>
                        <ErrorSpan :error="errors.scheme_id" />
                    </div>

                    <div class="col-md-6 mb-16">
                        <label for="">NAV</label>
                        <input type="number" class="form-control" v-model="item.nav" step=".01" />
                        <ErrorSpan :error="errors.nav" />
                    </div>


                    <div class="col-md-6 mb-16">
                        <label for="">Type</label>
                        <select name="type" class="form-select" :class="{ 'border-red': errors.type }" v-model="item.type">
                            <option value="" selected>Select Type</option>
                            <option value="weekly"> Weekly</option>
                            <option value="monthly"> Monthly</option>
                            <option value="daily"> Daily</option>
                        </select>
                        <ErrorSpan :error="errors.type" />
                    </div>

                    <div class="col-md-6 mb-16">
                        <label for="">Date</label>
                        <input type="date" class="form-control" v-model="item.date" />
                        <ErrorSpan :error="errors.date" />
                    </div>

                    <div class="col-md-6 mb-16">
                        <label for="">Published Date</label>
                        <input type="date" class="form-control" v-model="item.published_date" />
                        <ErrorSpan :error="errors.published_date" />
                    </div>

                    <div class="col-md-6 mb-16">
                        <label for="">Published On</label>
                        <input type="text" class="form-control" v-model="item.published_on" />
                        <ErrorSpan :error="errors.published_on" />
                    </div>

                    <div class="col-md-6 mb-16">
                        <label for="">Week</label>
                        <input type="text" class="form-control" v-model="item.week" />
                        <ErrorSpan :error="errors.week" />
                    </div>

                    <div class="col-md-6 mb-16">
                        <label for="">Month</label>
                        <input type="text" class="form-control" v-model="item.month" />
                        <ErrorSpan :error="errors.month" />
                    </div>

                    <div class="row mb-16">
                        <div class="col-md-6 ">
                            <!-- :type="'file'" -->
                            <label for="">File</label>
                            <UploadedFile :file='storage + item.file' :clearUploadedFile="clearUploadedFile"
                                v-if="mode === 'Edit' && item.file" />
                            <input type="file" class="form-control" ref="file" @input="handleFileUpload" v-else />
                            <ErrorSpan :error="errors.file" />
                        </div>
                    </div>

                    <div class="col-md-12 mb-16">
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault1"
                                v-model="item.status" />
                            <label class="form-check-label" for="flexSwitchCheckDefault">Status</label>
                        </div>
                    </div>

                    <div class="col-md-12 mb-16">
                        <label for="">Scheduled on</label>
                        <input type="date" class="form-control" v-model="item.scheduled_on" />
                        <ErrorSpan :error="errors.scheduled_on" />
                    </div>



                    <hr>
                    <div class="col-md-12">
                        <button type="button" aria-label="Close" data-bs-dismiss="offcanvas" class="btn btn-red mr-16">
                            <i class="ic-close mr-8"></i>Cancel
                        </button>
                        <button v-if="!isLoading" class="btn btn-green" type="submit">
                            <i class="ic-checkmark mr-8"></i>Save
                        </button>
                        <button v-else class="btn btn-green" type="button" disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import CreateMixin from "@/mixins/create.vue"
import ErrorSpan from "@/components/errorspan.vue";
import UploadedFile from "@/components/Utility/UploadedFile.vue";
import SlugMixin from "@/mixins/SlugMixin.vue";
import MediasMixin from "@/mixins/MediasMixin.vue";


export default {
    name: "MFNAVModal",
    mixins: [CreateMixin, SlugMixin, MediasMixin],
    props: ["schemes"],
    components: { ErrorSpan, UploadedFile },
    data() {
        return {
            url: 'mutual-fund-nav',
            mode: "",
            fetch_module: 'FETCH_MUTUAL_FUND_NAVS'
        };
    },
    mounted() {
        this.$root.$on('CREATE', () => {
            this.isEdit = false;
            this.item = {
                status: 0,
            };
            this.errors = {};
            this.mode = "Add";
            this.clearselectedFiles();

        });

        this.$root.$on('EDIT', (data) => {
            this.isEdit = true;
            this.item = { ...data };
            this.mode = "Edit";
            this.errors = {};
            this.clearselectedFiles();
        });

    },
};
</script>


